import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminActions } from "../../../redux/actions";
import { Beat } from "../../../redux/reducers/spinner";

export default function CompleteOrder({ id }) {
  let user = JSON.parse(localStorage.getItem("user"));
  let teamId = JSON.parse(localStorage.getItem("teamId"));
  const company_id = user?.data?.groups[teamId]?.company_id;

  const dispatch = useDispatch();

  const { accepting, companySettings } = useSelector((state) => state.admin);

  const [open, setOpen] = useState(false);
  const [shortCode, setShortCode] = useState("");
  const [error, setError] = useState("");

  console.log(
    "companySettings?.enforce_short_code",
    companySettings?.enforce_short_code
  );
  function handleOpenModal() {
    console.log("handleOpenModal called", { company_id, id });

    // Only open modal if enforce_short_code is true
    if (companySettings?.enforce_short_code === true) {
      setOpen(true);
      setShortCode("");
      setError("");
    } else {
      // Directly complete order without short code
      accept();
    }
  }

  function handleClose() {
    setOpen(false);
    setShortCode("");
    setError("");
  }

  function handleShortCodeChange(e) {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
    setShortCode(value);
    setError("");
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (shortCode.length !== 4) {
      setError("Please enter a 4-digit short code");
      return;
    }
    // Complete order with short code
    dispatch(
      adminActions.completeOrder({
        courier_order_id: id,
        short_code: shortCode,
      })
    );
    handleClose();
  }

  function accept() {
    // Complete order without short code
    dispatch(adminActions.completeOrder({ courier_order_id: id }));
  }

  return (
    <div>
      <MDBContainer>
        <MDBBtn color="primary" onClick={handleOpenModal}>
          Complete Order
        </MDBBtn>

        <MDBModal isOpen={open} toggle={handleClose}>
          <form name="form" onSubmit={handleSubmit}>
            <MDBModalHeader toggle={handleClose}>
              Enter Short Code
            </MDBModalHeader>
            <MDBModalBody>
              <div className="text-left pt-4 px-3">
                <p>
                  Please enter the 4-digit short code to complete this order:
                </p>
                <div className="form-group">
                  <input
                    type="text"
                    className={`form-control ${error ? "is-invalid" : ""}`}
                    value={shortCode}
                    onChange={handleShortCodeChange}
                    placeholder="Enter 4-digit code"
                    maxLength="4"
                    autoFocus
                  />
                  {error && <div className="invalid-feedback">{error}</div>}
                </div>
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color="secondary" onClick={handleClose}>
                Cancel
              </MDBBtn>
              <MDBBtn color="primary" type="submit">
                {accepting === true ? (
                  <Beat loading={true} />
                ) : (
                  "Complete Order"
                )}
              </MDBBtn>
            </MDBModalFooter>
          </form>
        </MDBModal>
      </MDBContainer>
    </div>
  );
}
